import { render } from "./CustomerProfile.vue?vue&type=template&id=66447ebf&scoped=true"
import script from "./CustomerProfile.vue?vue&type=script&lang=js"
export * from "./CustomerProfile.vue?vue&type=script&lang=js"

import "./CustomerProfile.vue?vue&type=style&index=0&id=66447ebf&scoped=true&lang=css"
import "./CustomerProfile.vue?vue&type=style&index=1&id=66447ebf&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66447ebf"]])

export default __exports__